import React, { useRef, useState } from "react";
import _ from "lodash";
import "react-activity-feed/dist/index.css";
import { DefaultTextEditor } from "components/TextEditors";
import { generateGuid } from "core/utils/str";
import { ICommentContent } from "interfaces/comment";
import { styled } from "@mui/material/styles";
import { RawDraftContentState } from "draft-js";

interface CommentEditorProps {
  onSubmit: (comment: ICommentContent) => void;
  onCancel?: () => void;
  comment?: ICommentContent;
}

export const CommentEditor = ({
  onSubmit,
  onCancel = () => {},
  comment = undefined
}: CommentEditorProps): JSX.Element => {
  const isEditMode: boolean = comment !== undefined;

  const [commentText, setCommentText] = useState<RawDraftContentState>({
    blocks: [],
    entityMap: {}
  });
  const textEditorRef = useRef<{ reset: () => void; focus: () => void }>();

  function onCommentChange(e: {
    target: { value: RawDraftContentState };
  }): void {
    setCommentText(e.target.value);
  }

  function onInterAddReaction(): void {
    onSubmit({ content: _.cloneDeep(commentText) });

    if (!isEditMode) {
      textEditorRef?.current?.reset();
      setCommentText({ blocks: [], entityMap: {} });
    }
  }

  return (
    <Editor
      value={comment?.content}
      editMode={isEditMode}
      cancelEditMode={onCancel}
      onChanged={onCommentChange}
      editorKey={`commentEditor-${generateGuid()}`}
      variant="small"
      name="comment"
      ref={textEditorRef}
      onInterAddReaction={onInterAddReaction}
    />
  );
};

const Editor = styled(DefaultTextEditor)`
  background-image: none;
  width: 100%;
` as any; // TODO: fix this
